import { Controller } from "@hotwired/stimulus";
import { createTimeline, stagger } from "animejs";

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.#revealBarsStatic();
      return;
    }
    this.#run();
  }

  #run() {
    const tl = createTimeline({ defaults: { easing: "easeOutCubic" } });

    const chips = this.element.querySelectorAll(".stat-chip");
    if (chips.length) {
      chips.forEach((c) => Object.assign(c.style, { opacity: 0, transform: "translateY(8px)" }));
      tl.add(chips, {
        opacity: [0, 1],
        translateY: [8, 0],
        duration: 300,
        delay: stagger(55),
      });
    }

    const bars = this.element.querySelectorAll("[data-bar-width]");
    if (bars.length) {
      bars.forEach((b) => {
        b.style.width = "0%";
      });
      tl.add(
        bars,
        {
          width: (el) => el.dataset.barWidth,
          duration: 550,
          easing: "easeOutQuart",
          delay: stagger(70),
        },
        "-=100",
      );
    }

    const rows = this.element.querySelectorAll("tbody tr");
    if (rows.length) {
      rows.forEach((r) => {
        r.style.opacity = 0;
      });
      tl.add(
        rows,
        {
          opacity: [0, 1],
          duration: 180,
          delay: stagger(25),
        },
        "-=150",
      );
    }
  }

  #revealBarsStatic() {
    this.element.querySelectorAll("[data-bar-width]").forEach((b) => {
      b.style.width = b.dataset.barWidth;
    });
  }
}
